module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEYAAABECAMAAAALOLO9AAAAM1BMVEX////ZnCTktWL358ztzpnown3bojXy27P9+fL57dn68+bhsFPv1KXryIv04cDmu2/fqkRV1txhAAABAUlEQVRYw+3WwY7DIAxF0Wcg4NIk7f9/7VSF6VPFAsWe1Yi7YRHpKCFIBtNuezoVzmqQVzn5lFuW1uZV6HgUOj6Fjk+h41Po+BQ63n2hY1JKW0DHpKAzdEzKh6FjUcjQMShkBueCQuaiU6kMDIK0jilzUBkZvUurzphAZWDoxBmz/yojQycrZoWujAydgnkxVgzM8PxKZL5bzGIWs5jF/C1TsshhZw6RXIDKuWRhSh+i8b0mK5PaEF3Mv2Ge8urpYXi+iptBTCnCw7DF+JnNymxfTFaborkzKu/upwU5+91fgSDuAoDoZyJ3yRj/jwbnJylaKduRnPBJ90cw9djbq/wA3/oJYk9GO2QAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/MSC-H5-0916_07.png
// module id = 1lcH
// module chunks = 1